import React, { useState } from 'react';
import axios from 'axios';
import styles from './Login.module.scss';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  // const apiURL = process.env.REACT_APP_URL;
  // console.log(apiURL,"url")

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/auth/login`, { email, password });
      login(res.data.token);
      navigate('/home');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
    <div className='bg_login'>
      <Container>
        <Row className="justify-content-center" style={{minHeight:'100vh'}}>
          <Col xs="12" lg="7" className='text-center align-self-center lft_bx'>
            <h1>What is Lorem Ipsum?</h1>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
          </Col>
          <Col xs="12" lg="5" className='align-self-center'>
            <div className='lg_bx'>
              <h2 className='text-start mb-4'>Why do we use it?</h2>
              <form className='' onSubmit={handleSubmit}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Email"
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Password"
              />
              <button type="submit">Login</button>
              </form>
              <p className='text-center pt-4'>Don't have an account? <Link to="/register">Sign Up</Link></p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  );
};

export default Login;
